module.exports = __webpack_public_path__ + "img/loading-evening.351866fb.jpg";